var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 6C8.52978 6 9.03849 6.21071 9.41356 6.58579C9.78864 6.96086 9.99935 7.46957 9.99935 8C9.99935 8.53043 9.78864 9.03914 9.41356 9.41421C9.03849 9.78929 8.52978 10 7.99935 10C7.46892 10 6.96021 9.78929 6.58513 9.41421C6.21006 9.03914 5.99935 8.53043 5.99935 8C5.99935 7.46957 6.21006 6.96086 6.58513 6.58579C6.96021 6.21071 7.46892 6 7.99935 6ZM7.99935 3C11.3327 3 14.1793 5.07333 15.3327 8C14.1793 10.9267 11.3327 13 7.99935 13C4.66602 13 1.81935 10.9267 0.666016 8C1.81935 5.07333 4.66602 3 7.99935 3ZM2.11935 8C2.65819 9.1002 3.49489 10.0272 4.53433 10.6755C5.57378 11.3238 6.77428 11.6675 7.99935 11.6675C9.22442 11.6675 10.4249 11.3238 11.4644 10.6755C12.5038 10.0272 13.3405 9.1002 13.8793 8C13.3405 6.8998 12.5038 5.97283 11.4644 5.3245C10.4249 4.67616 9.22442 4.33245 7.99935 4.33245C6.77428 4.33245 5.57378 4.67616 4.53433 5.3245C3.49489 5.97283 2.65819 6.8998 2.11935 8Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d34bc01f2d020bb60eae08fba49fe566.svg";
export { ForwardRef as ReactComponent };